/* eslint-disable no-trailing-spaces */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import HOC from '../HOC';
import Container from '../../common/Container';
import { __ } from '../../locales';
import ResultItem from './components/ResultItem';
import LinkButton from '../../common/LinkButton';
import events from '../../app/events';
import { trackEvent } from '../../helpers/common';
import CustomButton from '../../common/CustomButton';

const quizType = {
  rf: {
    quiz: 'rfQuiz',
    data: 'recyclingFundamentals',
    landEvent: events.DZ_RF_QUIZ_RESULTS_LAND,
    takeTestAgainEvent: events.DZ_RF_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP,
    viewAllEvent: 'DZ_RF_QUIZ_RESULTS_VIEW_ALL_TAP'
  },
  lm: {
    quiz: 'lmQuiz',
    data: 'learningModules',
    landEvent: 'DZ_LM_QUIZ_RESULTS_LAND',
    takeTestAgainEvent: 'DZ_LM_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP',
    viewAllEvent: 'DZ_RF_QUIZ_RESULTS_VIEW_ALL_TAP'
  },
  mum: {
    quiz: 'mumQuiz',
    data: 'misundestoodMaterials',
    landEvent: events.DZ_MM_QUIZ_RESULTS_LAND,
    takeTestAgainEvent: events.DZ_MM_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP,
    viewAllEvent: 'DZ_MM_QUIZ_RESULTS_VIEW_ALL_TAP'
  }
};

const Title = styled.h3`
  margin-bottom: 10px;
`;

const QuizResults = ({
  quizData
}) => {
  const { state } = useLocation();
  const [showAll, setShowAll] = useState(false);
  const { type } = useParams();
  const { replace } = useHistory();
  const quizes = state?.isLearningModule ? quizData.quizState[quizType[type].quiz][state.lmIndex]
    : quizData.quizState[quizType[type].quiz];
  const windowRef = useRef(window);

  // eslint-disable-next-line no-nested-ternary
  const title = (type === 'rf') ? __('app.recycling_fundamentals') : __('app.misunderstood_materials');

  const { total, ...quizItems } = quizes;

  const didPass = Object
    .keys(quizes)
    .map((key) => quizes[key])
    .filter(({ passed }) => passed).length >= (total - 1);

  const haveAtLeastOneMistake = Object
    .keys(quizes)
    .map((key) => quizes[key])
    .some(({ failed }) => failed);

  useEffect(() => {
    trackEvent(quizType[type].landEvent);
  }, [type]);

  return (
    <div>
      <Container>
        {type !== 'lm' ? (
          <Title>
            {title}
            {' '}
            -
            {' '}
            {__('app.answer_sheet')}
          </Title>
        ) : (
          <Title>

            {__('app.answer_sheet')}
          </Title>
        )}

        {
          Object
            .keys(quizItems)
            .map((key) => quizes[key])
            .map((data) => (
              <ResultItem
                data={data}
                showCorrectAnswers={showAll}
              />
            ))
        }
        {
          !didPass
            ? (
              <CustomButton
                className="btn filled royal"
                onClick={() => {
                  trackEvent(quizType[type].takeTestAgainEvent);
                  replace(`/quiz/${type}/0`, {
                    lmIndex: state?.lmIndex,
                    isLearningModule: state?.isLearningModule
                  });
                }}
              >
                {__('app.take_the_test_again')}
              </CustomButton>
            ) : null
        }
        {
          haveAtLeastOneMistake
            ? (
              <CustomButton
                className="btn outline royal"
                onClick={() => {
                  windowRef.current.scrollTo(0, 0);
                  if (!showAll) trackEvent(quizType[type].viewAllEvent);
                  return setShowAll(!showAll);
                }}
              >
                {
                  showAll
                    ? __('app.hide_correct_answers')
                    : __('app.view_all_answers')
                }
              </CustomButton>
            ) : null
        }
        <LinkButton onClick={() => replace('/landing')}>
          {__('app.quit')}
        </LinkButton>
      </Container>
    </div>
  );
};

export default HOC(QuizResults);
